import React from "react";
import "../Styles/AboutUs.css";
import OrnamentalDivider from "./OrnamentalDivider";
import cuisineIcon from "../Images/icons/cuisine.png";
import priceIcon from "../Images/icons/price.png";
import bookingsIcon from "../Images/icons/bookings.png";
import vegetarianIcon from "../Images/icons/vegetarian.png";

function AboutUs() {
  return (
    <section className="aboutUs" aria-labelledby="about-heading">
      <h2 id="about-heading">About Us</h2>
      <OrnamentalDivider />
      <p>
        Welcome to <strong>The Old House Restaurant</strong>, a family-run
        restaurant in the heart of Afantou village, Rhodes.{" "}
        <strong>Since 1986</strong>, we have served traditional Greek and Rhodian
        cuisine prepared from locally sourced ingredients - vegetables from
        nearby gardens, olive oil from the island's groves, herbs from our own
        terrace.
      </p>
      <p>
        Our dining room was named after the old stone houses of Rhodes, and we
        have furnished it to recall their quiet warmth.
      </p>
      <p>
        Whether you join us for{" "}
        <strong>moussaka, slow-cooked lamb, fresh-cut chops,</strong> or a
        simple plate of meze and a glass of local wine, our hope is the same:
        that for an hour or two you{" "}
        <strong>feel like a guest in our family home.</strong>
      </p>

      <OrnamentalDivider variant="leaf" />

      <h3>What to expect</h3>
      <ul className="expect-list">
        <li><img src={cuisineIcon}    alt="" /> Traditional Greek cuisine</li>
        <li><img src={priceIcon}      alt="" /> 8 - 18 euro per person</li>
        <li><img src={bookingsIcon}   alt="" /> Reservations welcome</li>
        <li><img src={vegetarianIcon} alt="" /> Vegan options</li>
      </ul>
    </section>
  );
}

export default AboutUs;
